import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupWindowStaticTitle from "../components/PiPopupWindowStaticTitle";
import SetOutfitPreviewBody from "./SetOutfitPreviewBody";

export default function SetOutfitPreview() {
  return (
    <PiPopupWindowPreview
      title={<PiPopupWindowStaticTitle title="Set Outfit" />}
      body={<SetOutfitPreviewBody />}
      size="medium"
    />
  );
}
